export default defineComponent({
  name: 'BaseScrollContainer',
  props: {
    isCenterAligned: {
      type: Boolean,
      default: false
    },
    hasOverflowVisible: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup() {
    var scrollContainer = ref(null);
    var startX = null;
    var scrollLeft = null;
    function onMouseDown(event) {
      startX = event.pageX;
      scrollLeft = scrollContainer.value.scrollLeft;
    }
    function onMouseMove(event) {
      if (!startX) {
        return;
      }
      var x = event.pageX;
      var walk = x - startX;
      scrollContainer.value.scrollLeft = scrollLeft - walk;
    }
    function onMouseUp() {
      startX = null;
      scrollLeft = null;
    }
    function onTouchStart(event) {
      startX = event.touches[0].pageX;
      scrollLeft = scrollContainer.value.scrollLeft;
    }
    function onTouchMove(event) {
      if (!startX) {
        return;
      }
      var x = event.touches[0].pageX;
      var walk = x - startX;
      scrollContainer.value.scrollLeft = scrollLeft - walk;
    }
    function onTouchEnd() {
      startX = null;
      scrollLeft = null;
    }
    return {
      scrollContainer: scrollContainer,
      onMouseDown: onMouseDown,
      onMouseMove: onMouseMove,
      onMouseUp: onMouseUp,
      onTouchStart: onTouchStart,
      onTouchMove: onTouchMove,
      onTouchEnd: onTouchEnd
    };
  }
});